/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
window.addEventListener('load', function(){

    if(window.location.href.indexOf('/products') > -1 )
    {

      //handle preselected x-tail variant 
      if(window.location.href.indexOf('variant=') > -1 ){

        pJson = JSON.parse( document.querySelector('script[data-product-json]').innerText);
        selectedVariant = pJson.product.variants.filter(function(v){
          return v.id == pJson.selected_variant_id;
        })[0]
        document.querySelector('section[data-section-type="product"]').dispatchEvent(new CustomEvent('variant:changed',
        {
            detail: { variant : selectedVariant }
        }));
      }
      
      // product videos blocks 
      var videos = document.querySelectorAll('.product-carousel__video');
      function isScrolledIntoView(el) {
          var rect = el.getBoundingClientRect();
          var elemTop = rect.top;
          var elemBottom = rect.bottom;
      
          // Only completely visible elements return true:
          var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
          // Partially visible elements return true:
          //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
          return isVisible;
      }
      window.addEventListener('scroll', function(){
        for(var i=0; i< videos.length; i++){
          if(isScrolledIntoView(videos[i])){
            videos[i].play();
          }
        }  
      });
        //handle reviews click 
        document.querySelector('.view-all-reviews').addEventListener('click', function(){
          document.querySelector('.stamped-product-reviews-badge').click();
        });
        //same for shipping
        document.querySelector('.shipping-click').addEventListener('click', function(){
          document.getElementById('toggle_shipping').click();
          document.getElementById('toggle_shipping').scrollIntoView(true, {behavior : 'smooth', block: 'center'});
        })
        //product page custom scripts
        var countryCode = theme.userCountry === 'CA' || theme.userCountry === 'US' ? theme.userCountry : 'other';
        function _setupShippingTab(targetCountry) {
          var firstButton, secondButton;
      
          if (targetCountry === null) {
            document.querySelector('[data-product-shipping="'+countryCode+'"]').classList.add('active');
          } else {
            countryCode = targetCountry;
          }
      
          if (countryCode === 'CA') {
            firstButton = 'the <button class="Text--subdued" data-product-shipping-toggle="US">US</button>';
            secondButton = '<button class="Text--subdued" data-product-shipping-toggle="other">internationally</button>';
          } else if (countryCode === 'US') {
            firstButton = '<button class="Text--subdued" data-product-shipping-toggle="CA">Canada</button>';
            secondButton = '<button class="Text--subdued" data-product-shipping-toggle="other">internationally</button>';
          } else {
            firstButton = '<button class="Text--subdued" data-product-shipping-toggle="CA">Canada</button>';
            secondButton = 'the <button class="Text--subdued" data-product-shipping-toggle="US">US</button>';
          }
      
          document.querySelector('[data-product-shipping-alternatives]').innerHTML = (`Shipping to ${firstButton} or ${secondButton}?`);
        }

        _setupShippingTab(null);
            
        document.addEventListener('click', function(event){
            if(event.target && event.target.getAttribute('data-product-shipping-toggle')){
                event.preventDefault();
                var target = event.target.getAttribute('data-product-shipping-toggle');
                countryCode = target === 'CA' || target === 'US' ? target : 'other';
            
                var targetElement = document.querySelector('[data-product-shipping="'+target+'"]');
                targetElement.classList.add('active');
                var sibling = targetElement.parentNode.firstElementChild;
    
                while(sibling){
                    if(sibling != targetElement ){
                        sibling.classList.remove('active');
                    }
                    sibling = sibling.nextElementSibling;
                };
                _setupShippingTab(target);
            }
        });
    };

    //dynamic checkout update 
    document.addEventListener('variant:changed', function(e){
      if(e.detail && e.detail.variant){
        document.querySelector('.shopify-payment-button__button').setAttribute('href', '/cart/'+ e.detail.variant.id +':'+document.querySelector('.QuantitySelector__CurrentQuantity').value)
      }
    })

 });